import UpdateFunding from "./UpdateFunding";

export default UpdateFunding;
